import styled from "styled-components";
import { List, Type } from "@ebscois/react-component-library";

export const StyledList = styled(List)`
  color: ${({ theme }) => theme.colors.gray700};
  list-style: disc;
  padding-left: 0.25rem;
  margin-top: 1rem;
`;

export const StyledLabel = styled(Type)`
  margin-top: 1rem;
  font-weight: bold;
  &:nth-of-type(1) {
    margin-top: 0;
  }
`;

export const StyledFullTextDiv = styled.div`
  margin: ${({ theme }) => theme.space.md};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg};
  }
`;
